<script>
  import { onMount, afterUpdate, createEventDispatcher } from "svelte";
  import { Stack } from "creditdesign-svelte-components";
  //   import { ImageSlider } from "nature-immersive-svelte-components";
  import ImageSlider from "./components/ImageSlider/index.svelte";
  import ColorScale from "./components/ColorScale/index.svelte";

  export let ratio = 0.5625;
  export let imageData = [];
  export let headline;
  export let standFirst;
  export let message;
  export let credit;
  export let scaleLabel;

  let dispatch = createEventDispatcher();

  onMount(() => {
    dispatch("update");
  });

  afterUpdate(() => {
    dispatch("update");
  });
</script>

<style>
  .nature-interactive-graphic {
    padding-top: var(--s4);
    padding-bottom: var(--s4);
  }

  .credit {
    max-width: none;
    padding-bottom: 5px;
    font-size: var(--font-size-small-1);
    color: var(--black-2);
    border-bottom: 1px solid var(--black-3);
  }
</style>

<main class="nature-interactive-graphic font-family:sans-serif">
  <Stack stackSpace="var(--s1)">
    <Stack stackSpace="var(--s-1)">
      <h1 class="font-size:big-1">
        {@html headline}
      </h1>
      <p>
        {@html standFirst}
      </p>
    </Stack>

    <ColorScale {scaleLabel} />

    <ImageSlider ratio={parseFloat(ratio)} {imageData} {message} />

    <p class="credit">
      {@html credit}
    </p>
  </Stack>
</main>
